import React, { useState } from 'react'
import { UserProfile } from '../components/UserProfile'
import { Modal } from '../components/modals/Modal'
import { ButtonStyle } from '../widgetStyles/Styles'
import { Input } from './../components/Input'
import { Cameras } from './personal-area/Cameras'

export const PersonalArea = () => {
    const [isAdd, setAdd] = useState(false)

    const onAdd = () => {
        setAdd(true)
    }

    return (
        <div className="wrapper section fade-in">
            <div className="df jcsb">
                <div>
                    <div className="fs-b">Personal Area</div>
                </div>
                <UserProfile />
            </div>
            <ButtonStyle className="input_button df mtn" onClick={onAdd}>
                <img src="./img/icons/add.svg" alt="add" className="icon mla" style={{marginRight: "10px"}} />
                <span>Add new camera</span>
            </ButtonStyle>
            <Cameras camName={"Staircase second floor"} videoPath="./video/crowd.mp4" isOk={true} />
            <Cameras camName={"Main Hall"} videoPath="./video/bridge-crowd.mp4" isOk={true} />
            <Cameras camName={"Street front"} videoPath="./video/crowd.mp4" isOk={true} />
            <Cameras camName={"Street back"} isOk={false} />
            <Cameras camName={"Dining room on the first floor"} isOk={false} />
            {isAdd &&
            <Modal onCancel={() => setAdd(false)}>
                <div className="fs-b">Add new camera</div>
                <div className="fs-s mtn">Enter your camera details</div>
                <div className="mtn">
                    <Input type="text" hint="Name" />
                    <Input type="text" hint="Manufacturer" />
                    <Input type="text" hint="IP" />
                </div>
                <ButtonStyle className="input_button mtn" onClick={() => setAdd(false)}>Done</ButtonStyle>
            </Modal>
            }
        </div>
    )
}


